
export const browserRoutes = [
  {
    path: 'admin',
    loadChildren: () => import('./admin-dashboard/admin-dashboard.module').then((mod) => mod.AdminDashboardModule),
  },
];
